import { Menu as ChakraMenu } from '@chakra-ui/react';

type MenuProps = React.ComponentProps<typeof ChakraMenu> & {
  onClose: () => void;
  display: string;
  children: Element[] | React.ReactNode;
};

const Menu = ({ children, ...props }: Readonly<MenuProps>) => {
  return <ChakraMenu {...props}>{children}</ChakraMenu>;
};

export default Menu;
